import React, { FC, useLayoutEffect, useRef, useState } from "react";
import classNames from "classnames";
import "./index.scss";

export type TabsType = {
  tabs: string[];
  currentSelected: string;
  handleChange: (name: string) => () => void;
};

const Tabs: FC<TabsType> = ({ tabs, currentSelected, handleChange }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const tabRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const [sliderStyle, setSliderStyle] = useState({ left: 0, width: 0 });

  useLayoutEffect(() => {
    const currentTab = tabRefs.current[currentSelected];
    if (currentTab && containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const tabRect = currentTab.getBoundingClientRect();
      setSliderStyle({
        left: tabRect.left - containerRect.left + containerRef.current.scrollLeft,
        width: tabRect.width,
      });
    }
  }, [currentSelected, tabs]);

  return (
    <div className="tabs-wrapper" ref={containerRef}>
      <div className="tabs-list">
        {tabs.map((tab) => (
          <div
            key={tab}
            ref={(el) => (tabRefs.current[tab] = el)}
            onClick={handleChange(tab)}
            className={classNames("menu-item", { selected: currentSelected === tab })}
          >
            <p>{tab}</p>
          </div>
        ))}
      </div>

      <div className="underline">
        <div
          className="slider"
          style={{
            width: `${sliderStyle.width}px`,
            transform: `translateX(${sliderStyle.left}px)`,
          }}
        />
      </div>
    </div>
  );
};

export default Tabs;
